import React, { useState, useEffect } from 'react';
import lodash from 'lodash';
import PropTypes from 'prop-types';
import PhoneInput from 'react-phone-input-2';
import { useForm } from 'react-hook-form';
import Dropzone from 'react-dropzone';
import ImageCropper from '../modals/ImageCropper';
import {
  Button, Form, FormGroup, Label, Input,
} from 'reactstrap';
import { staticConstants, profileImageValidation, NUMERIC_VALUE } from '../../utils';
import InputError from '../shared/elments/InputError';

function EditManagerDetail(props) {
  const { toggle, submitCallBack } = props;
  const [form, setForm] = useState({
    contactNumber: '',
  });

  const [contactEmail, setContactEmail] = useState();
  const [managerImage, setManagerImage] = useState();
  const [image, setImage] = useState();
  const [modalObj, setModalObj] = useState({});
  const [isOpenCropModal, setIsOpenCropModal] = useState(false);
  const [managerFileInputRandString, setArtistFileInputRandString] = useState(String(Math.random()));

  const {
    register, handleSubmit, errors, setValue, clearError, triggerValidation,
  } = useForm({ mode: 'onBlur', nativeValidation: false });

  const handleContactNumberChange = (phone) => {
    clearError('contactNumber');
    setValue('contactNumber', phone);
    setForm({ ...form, contactNumber: phone });
  };

  useEffect(() => {
    register({ name: 'contactNumber' }, { required: true, maxLength: NUMERIC_VALUE.TWENTY, minLength: NUMERIC_VALUE.TEN });
    profileImageValidation(register, 'managerImageUpload');
    if (props && props.data) {
      const currentUserData = props.data;
      const preFilledData = {
        contactNumber: currentUserData.contactNumber,
      };

      setValue([
        { managerFirstName: currentUserData.managerFirstName },
        { managerLastName: currentUserData.managerLastName },
        { companyName: currentUserData.companyName },
        { contactNumber: currentUserData.contactNumber },
      ]);
      setContactEmail(currentUserData.email);
      if(!managerImage) {
       setManagerImage(currentUserData.managerImage);
      }
      setForm({
        ...form, ...preFilledData,
      });
    }
  }, [props]);

  const onSubmit = (formData) => {
    const profileData = lodash.pick(formData, ['managerFirstName', 'managerLastName', 'companyName', 'contactNumber']);
    profileData.userId = props.data._id;
    if(managerImage) {
      profileData.managerImage = managerImage;
    }
    submitCallBack(profileData);
  };

  const handleImageSubmit = async (e, fieldName) => {
    const profileImageUpload = e[0];
    setValue(fieldName, e[0]);
    const success = await triggerValidation(fieldName);
    if (success) {
      setImage(profileImageUpload);
      setIsOpenCropModal(true);
      setModalObj({
        callback: (img) => setManagerImage(img),
      });
    }
  };

  const hideFileSelectModal = () => {
    setIsOpenCropModal(false);
    setArtistFileInputRandString(String(Math.random()));
  };

  return (
    <Form onSubmit={handleSubmit(onSubmit)}>
      <div className="modal-edit-manager-bio">
        <span>
        {isOpenCropModal && (
          <ImageCropper
            isOpen={isOpenCropModal}
            image={image}
            savedCroppedImage={modalObj.callback}
            onClose={hideFileSelectModal}
          />
          )}
        <Dropzone onDrop={(acceptedFiles) => handleImageSubmit(acceptedFiles, 'managerImageUpload')}>
          {({ getRootProps, getInputProps, isDragActive }) => (
            <section className={isDragActive ? 'DragActive' : ''}>
              <div {...getRootProps()} className="signup-form-image-section signup-form-edit-image-section">
                <input name="managerImageUpload" {...getInputProps()} key={managerFileInputRandString} multiple={false} accept="image/*" />
                <Label className={managerImage ? 'border-0' : ''}>
                  {managerImage ? (
                    <img
                      src={managerImage}
                      className="img-cover"
                      alt="profile"
                    />
                  )
                    : <></>}
                  <span>Upload artist picture <p className="required">*</p></span>
                  <em className="icon icon-camera" />
                </Label>
              </div>
            </section>
          )}
        </Dropzone>
        <InputError error={errors.managerImageUpload} className="image-error-text" max={NUMERIC_VALUE.TWO_HUNDRED} min={NUMERIC_VALUE.THREE} />
        </span>
        <div className="modal-edit-manager-bio-content">
          <p>{contactEmail}</p>
        </div>
      </div>
      <div className="modal-edit-manager-input">
        <div className="name-input-group">
          <FormGroup className={errors.managerFirstName ? `${staticConstants.ERROR_CLASS.FORM_ERROR}` : ''}>
            <Label
              for="firstName"
            >
              First name
            </Label>
            <Input
              type="text"
              name="managerFirstName"
              placeholder="Enter first name"
              value={form.managerFirstName}
              innerRef={register({ required: true })}
            />
            <InputError error={errors.managerFirstName} max={NUMERIC_VALUE.TWO_HUNDRED} min={NUMERIC_VALUE.THREE} />
          </FormGroup>
          <FormGroup className={errors.managerLastName ? `${staticConstants.ERROR_CLASS.FORM_ERROR}` : ''}>
            <Label
              for="lastName"
            >
              Last name
            </Label>
            <Input
              type="text"
              name="managerLastName"
              placeholder="Enter last name"
              value={form.managerLastName}
              innerRef={register({ required: true })}
            />
            <InputError error={errors.managerLastName} max={NUMERIC_VALUE.TWO_HUNDRED} min={NUMERIC_VALUE.THREE} />
          </FormGroup>
        </div>
        <FormGroup className={errors.companyName ? `${staticConstants.ERROR_CLASS.FORM_ERROR}` : ''}>
          <Label
            for="companyName"
          >
            Company name
          </Label>
          <Input
            type="text"
            name="companyName"
            placeholder="Enter company name"
            value={form.companyName}
            innerRef={register({ required: true })}
          />
          <InputError error={errors.companyName} max={NUMERIC_VALUE.TWO_HUNDRED} min={NUMERIC_VALUE.THREE} />

        </FormGroup>
        <FormGroup className={errors.contactNumber ? `${staticConstants.ERROR_CLASS.FORM_ERROR}` : ''}>
          <Label
            for="contactNumber"
          >
            Phone number
          </Label>
          <PhoneInput
            inputProps={{
              name: 'contactNumber',
              required: true,
            }}
            country="us"
            placeholder="Enter phone number"
            value={form.contactNumber}
            onChange={handleContactNumberChange}
          />
          <InputError error={errors.contactNumber} max={NUMERIC_VALUE.TWELVE} min={NUMERIC_VALUE.THREE} />
        </FormGroup>
      </div>
      <div className="modal-edit-artist-btn-group">
        <span onClick={toggle}>Cancel</span>
        <Button
          color="accept"
          type="submit"
        >
          Update
        </Button>
      </div>
    </Form>
  );
}

EditManagerDetail.propTypes = {
  toggle: PropTypes.func.isRequired,
  data: PropTypes.object.isRequired,
  submitCallBack: PropTypes.func.isRequired,
};

export default EditManagerDetail;
